var exports = {
  "aV": "blockedIssueIconWrapper__z5OgEU",
  "nb": "issueIcon__1KaoqR",
  "Q6": "blockedIcon__HxmJkL",
};

module.exports = exports;
